// =========================
// ハンバーガーメニューのスクロール制御
// =========================
// ハンバーガーメニューのスクロール制御（既存コードと独立）
$(function() {
  const $hamburgerButton = $('#js-buttonHamburger');
  const $menuLinks = $('.l-header-nav-item-anker');
  const $header = $('.js-l-header');
  
  // スクロール位置を保存する変数
  let scrollPosition = 0;
  
  // スクロールを無効化する関数
  function disableScroll() {
    $('html').css('overflow', 'hidden');
  }
  
  // スクロールを有効化する関数
  function enableScroll() {
    $('html').css('overflow', '');
  }
  
  // ハンバーガーボタンのクリックイベント（既存処理の後に実行）
  $hamburgerButton.on('click', function() {
    // 既存の処理が完了した後に状態をチェック
    setTimeout(function() {
      if ($header.hasClass('is-open')) {
        disableScroll();
      } else {
        enableScroll();
      }
    }, 10);
  });
  
  // メニューリンクのクリックイベント
  $menuLinks.on('click', function() {
    enableScroll();
  });
});

// =========================
// 企業ロゴスライダー
// =========================
let kvswiper;
const createkvswiper = () => {
  kvswiper = new Swiper(".js-p-top-kv-swiper", {
    loop: true,
    slidesPerView: 2,
    spaceBetween: 20,
    speed: 4500, // ループの時間
    allowTouchMove: false, // スワイプ無効
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      769: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1224: {
        speed: 6000,
        slidesPerView: 6,
        spaceBetween: 50,
      },
      1920: {
        slidesPerView: 9,
        spaceBetween: 100,
      },
    },
  });
};

createkvswiper();

window.addEventListener("pageshow", function (event) {
  if (event.persisted || window.performance.navigation.type === 2) {
    kvswiper.destroy(false, true);
    createkvswiper();
  }
});


// =========================
// サンプルイベントスライダー
// =========================
const swiper = new Swiper(".p-example-slideWrap", {
  loop: true,
  spaceBetween: 40,
  slidesPerView: 3.1,
  speed: 11000,
  allowTouchMove: false,
  
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },

  pagination: {
    el: ".js-p-use-sample-swiper-pagination",
    clickable: true,
  },
  
  navigation: {
    nextEl: ".p-sample-swiper-next",
    prevEl: ".p-sample-swiper-prev",
  },

  breakpoints: {
    0: {
      slidesPerView: 1.8,
      centeredSlides: true,
      speed: 900,
      autoplay: {
        delay: 1500,
      },
    },
    769: {
      slidesPerView: 3.1,
      centeredSlides: false,
      speed: 11000,
      autoplay: {
        delay: 0,
      },
    },
  },
});


// =========================
// ナビ現在地
// =========================
$(function() {
  const sections = $('section[id]');
  const navLinks = $('.l-header-nav-list a');
  const offset = 10; // ヘッダー分などズラしたい時の値

  // ---- スクロールで現在地表示 ----
  $(window).on('scroll', function() {
    const scrollPos = $(window).scrollTop();
    let currentId = '';

    sections.each(function() {
      const top = $(this).offset().top - offset;
      const bottom = top + $(this).outerHeight();

      if (scrollPos >= top && scrollPos < bottom) {
        currentId = $(this).attr('id');
        return false;
      }
    });

    navLinks.each(function() {
      const link = $(this);
      const targetId = link.attr('href').replace('#', '');

      if (targetId === currentId) {
        link.addClass('is-current');
      } else {
        link.removeClass('is-current');
      }
    });
  });
  
});




// =========================
// アンカーリンクのスムーススクロール・スクロール位置調整（SPのみ
// =========================

$(function () {
  $('a[href^="#"]').on('click', function (e) {
    e.preventDefault();

    var targetId = $(this).attr('href');
    var target = $(targetId);

    if (!target.length) return;

    // 画面幅 1024px 以下のときだけ 指定値をオフセット
    var offset = $(window).width() <= 1024 ? 30 : 0;

    $('html, body').animate(
      {
        scrollTop: target.offset().top - offset
      },
      500,
      'swing'
    );
  });
});